import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as Adapters from '../../adapters/status-tracker/index';
import { Configs } from '../../models/status-tracker/aem/aem-status-tracker.interfaces';
import {
  State,
  STATUS_TRACKER_FEATURE_KEY,
  statusTrackerAdapter
} from '../reducers/status-tracker.reducer';

const { selectEntities } = statusTrackerAdapter.getSelectors();

export const getStatusTrackerState = createFeatureSelector<State>(
  STATUS_TRACKER_FEATURE_KEY
);

export const getStatusTrackerEntities = createSelector(
  getStatusTrackerState,
  (state: State) => selectEntities(state)
);

export const getServiceConfiguration = createSelector(
  getStatusTrackerEntities,
  (statusTrackerEntities) =>
    Adapters.getServiceConfiguration(
      statusTrackerEntities['aem-summary-content']?.aemSummaryContent
        ?.configs || ({} as Configs)
    )
);

export const getTrackerContent = createSelector(
  getStatusTrackerEntities,
  (statusTrackerEntities) =>
    statusTrackerEntities['status-tracker-content']?.statusTrackerContent
);

export const getFutureActivityRequest = createSelector(
  getStatusTrackerEntities,
  (statusTrackerEntities) =>
    Adapters.getFutureActivityRequest(
      statusTrackerEntities['status-tracker-content']?.statusTrackerContent,
      statusTrackerEntities['status-tracker-content']?.statusTrackerContent
        ?.carrierCode
    )
);

export const getTracker = createSelector(
  getStatusTrackerEntities,
  (statusTrackerEntities) => {
    return Adapters.getTracker(
      statusTrackerEntities['status-tracker-content']?.statusTrackerContent,
      statusTrackerEntities['future-activity-content']?.futureActivityContent,
      statusTrackerEntities['aem-summary-content']?.aemSummaryContent?.tracker,
      [
        statusTrackerEntities['status-tracker-content-error']
          ?.statusTrackerContentError,
        statusTrackerEntities['future-activity-content-error']
          ?.futureActivityContentError
      ],
      statusTrackerEntities['aem-summary-content']?.aemSummaryContent
        ?.errorMessagesSection?.errormessages
    );
  }
);
